exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tags-view-container[data-v-fac8ca64]{height:100%}.tags-view-container .contextmenu[data-v-fac8ca64]{margin:0;background:#fff;z-index:3000;position:absolute;list-style-type:none;padding:5px 0;border-radius:4px;font-size:12px;font-weight:400;color:#333;-webkit-box-shadow:2px 2px 3px 0 rgba(0,0,0,.3);box-shadow:2px 2px 3px 0 rgba(0,0,0,.3)}.tags-view-container .contextmenu li[data-v-fac8ca64]{margin:0;padding:7px 16px;cursor:pointer}.tags-view-container .contextmenu li[data-v-fac8ca64]:hover{background:#eee}", ""]);

// exports
